export const LAST_WATERMARK_LS_KEY = "exportTasks.lastWatermarkUrl";

// MIME-контракт между WatermarkGallery (onDragStart) и preview drop-zone
// в WatermarkOptionsForm. text/uri-list — то, что мы кладём и реально читаем;
// text/plain держим только как fallback на drop, не как сигнал «принять drag».
export const DRAG_MIME_URI_LIST = "text/uri-list";
export const DRAG_MIME_PLAIN = "text/plain";

export const LABELS = {
  urlLabel: "Или вставьте прямую ссылку",
  restore: "Использовать последнее",
  urlHint:
    "PNG с прозрачным фоном даст лучший результат. Лого должно быть доступно по публичной ссылке.",
  previewTitle: "Превью",
  previewHint:
    "Перетащите лого в нужное место и потяните за уголок, чтобы изменить размер. Так же оно будет смотреться в выгрузке.",
  emptyHint: "Выберите лого в галерее выше или перетащите его сюда",
  dropHere: "Отпустите, чтобы установить лого",
  urlPlaceholder: "https://example.com/logo.png",
  urlInvalidError: "Ссылка должна начинаться с http(s)://",
  clearTitle: "Очистить",
} as const;

export const DEFAULT_POSITION_X = 70;
export const DEFAULT_POSITION_Y = 70;
export const DEFAULT_SIZE = 20;

// Sharp на бэке нарисует любой размер; ограничиваем лишь чтобы знак
// не схлопывался в точку и не выезжал за пределы холста.
export const MIN_SIZE = 1;
export const MAX_SIZE = 100;

export const WATERMARK_MAX_SIZE_BYTES = 5 * 1024 * 1024;
export const WATERMARK_MAX_PER_USER = 50;
export const WATERMARK_ACCEPT_MIME = "image/png,image/jpeg,image/webp";
export const WATERMARK_ACCEPT_TYPES = ["image/png", "image/jpeg", "image/webp"];
